import { Alert, Box, Typography } from '@mui/material'
import React from 'react'
import { GuestAdoptionError } from '../../../domain/Adopters/GuestAdoption'
import { useAccountsStore } from '../../../store/AccountsStore'
import { StripeConnectButton } from '../StripeConnectButton'

interface Props {
  error: GuestAdoptionError
}

export const GuestAdoptionErrorAlert: React.FC<Props> = ({ error }) => {
  const accountsStore = useAccountsStore()

  return (
    <Alert severity="error">
      {error.message}
      {error.stripeOnboardingRequired && (
        <Box sx={{ mt: 1 }}>
          <StripeConnectButton
            variant="outlined"
            color="error"
            fullWidth={false}
            content="Terminer la configuration Stripe"
            sx={{ textTransform: 'none' }}
          />
          {!accountsStore.isAdmin() && (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Demandez à un administrateur de votre association d&apos;activer Stripe Connect pour continuer.
            </Typography>
          )}
        </Box>
      )}
    </Alert>
  )
}
